const defaultState = () => {
	return {
		auditControlStatusList: null,
      auditControlApplicabilityList: null,
      auditControlAppliedList: null,
		auditEvidenceRequirementStatusList: null,
      auditTaskStatusList: null,
	}
}

const state = () => ({
	auditControlStatusList: null,
   auditControlApplicabilityList: null,
   auditControlAppliedList: null,
   auditEvidenceRequirementStatusList: null,
   auditTaskStatusList: null,
});

const getters = {}

const actions = {
   resetState({ commit }) {
      commit("resetState")
   },
};

const mutations = {
   resetState(state) {
      Object.assign(state, defaultState());
   },

   setAuditControlStatusList(state, list) {
      state.auditControlStatusList = list
   },

   setAuditControlApplicabilityList(state, list) {
      state.auditControlApplicabilityList = list
   },

   setAuditControlAppliedList(state, list) {
      state.auditControlAppliedList = list
   },

   setAuditEvidenceRequirementStatusList(state, list) {
      state.auditEvidenceRequirementStatusList = list
   },

   setAuditTaskStatusList(state, list) {
      state.auditTaskStatusList = list
   }
};

export default {
   name: "audit",
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};